<template>
  <i-modal
    v-model="modal"
    @on-visible-change="onVisibleChange"
    title="一括物件削除"
    width="600"
    class="modal-bulk_room_delete"
  >
    <div class="contanier">
      以下の物件を削除します。<br />
      物件を削除すると元に戻せません。
      <div class="list-wrap">
        <ul>
          <template v-for="(item, idx) in select">
            <li :key="idx" class="list__item">{{ item.control_no }} {{ item.b_name }}</li>
          </template>
        </ul>
      </div>
    </div>
    <div slot="footer">
      <i-button type="default" @click="onClickCancel">キャンセル</i-button>
      <i-button type="error" @click="onClickDelete">削除</i-button>
    </div>
  </i-modal>
</template>

<script>
import { Modal, Button } from 'view-design'
import BukkenRepository from '@/repositories/bukkenRepository'
export default {
  components: {
    'i-modal': Modal,
    'i-button': Button,
  },
  data() {
    return {}
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalPropertyBulkDelete/getModal']
      },
      set(val) {
        this.$store.commit('ModalPropertyBulkDelete/setModal', val)
      },
    },
    select: {
      get() {
        return this.$store.getters['SelectProperty/getProperty']
      },
      set(val) {
        this.$store.commit('SelectProperty/setProperty', val)
      },
    },
  },
  methods: {
    // モーダル 表示/非表示時の処理
    async onVisibleChange(isOpen) {
      if (isOpen) {
        // 表示処理
      } else {
        setTimeout(this.resetParam, 300)
      }
    },
    // モーダル キャンセル時の処理
    onClickCancel() {
      this.modal = false
    },
    // 括削除ボタン クリック処理
    onClickDelete() {
      const params = _.map(this.select, item => {
        return item.id
      })
      this.deleteBuld(params)
    },
    // 部屋一括削除 実行
    async deleteBuld(params) {
      this.$store.dispatch('Loading/setLoading', true)
      await BukkenRepository.deleteBulk(params)
        .then(data => {
          if (data.result) {
            let property = this.$store.getters['Property/getProperty']
            let status = this.$store.getters['SearchProperty/getStatus']
            _.forEach(params, function(id) {
              property = _.reject(property, {
                id: id,
              })
            })
            status.total = status.total - params.length
            status.to = status.to - params.length
            if (status.to === 0) status.from = 0

            this.$store.commit('Property/setProperty', property)
            this.$store.dispatch('SelectProperty/reset')
            this.$store.commit('SearchProperty/setStatus', status)

            alert('物件一括削除しました。')
            this.modal = false
          } else {
            alert('物件一括削除に失敗しました。')
          }
        })
        .catch(e => {
          console.log(e)
          alert('物件一括削除に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // パラメータをリセットする
    resetParam() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-bulk_room_delete {
  .container {
    position: relative;
  }
  .list {
    &-wrap {
      min-height: 60px;
      max-height: 200px;
      overflow-y: scroll;
      margin-top: 16px;
    }
    &__item {
      margin-bottom: 4px;
      font-weight: bold;
    }
  }
}
</style>
